__webpack_require__.p = "/kurumsal/aksa-deneyim-alani/sanaltur/ingilizce/_next/";